<div class="top-home-logout">
  <!-- <div class="home">
    <p-button

      type="button"
      (click)="setHome()"
      [routerLink]="'/'"
      label="Home"
    ></p-button>
  </div> -->
  <div
    [routerLink]="'/stocks'"
    routerLinkActive="selected"
    [routerLinkActiveOptions]="{ exact: true }"
    class="title"
  >
    {{ title }}
  </div>
  <app-notification-manager></app-notification-manager>

  <!-- <div class="logout">
    <p-button

      type="button"
      (click)="logout()"
      label="{{ userLoggedIn ? 'Logout' : 'Login' }}"
    ></p-button>
  </div> -->
  <span class="appVersion">
    {{ connectedToProd() ? "prod v" : "dev v" }} {{ appVersion }}
    <span class="appVersionDate"> (ng {{ angularVersion }}) </span>
  </span>
</div>
<app-allpaths />
<router-outlet />
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  [fullScreen]="true"
>
  <p style="color: white">Loading...</p>
</ngx-spinner>
<p-scrollTop />
